import React from 'react';
import * as Sentry from '@sentry/react';

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean, error: Error | null }> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    Sentry.captureException(error, { extra: { componentStack: errorInfo.componentStack } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black text-red-500 flex flex-col items-center justify-center font-mono p-8">
          <h1 className="text-4xl font-bold mb-4">SYSTEM CRITICAL FAILURE</h1>
          <p className="text-xl mb-8">An unrecoverable error has occurred.</p>
          <pre className="bg-red-900/20 p-4 rounded border border-red-500/50 max-w-2xl overflow-auto">
            {this.state.error?.toString()}
          </pre>
          <button
            onClick={() => window.location.reload()}
            className="mt-8 px-6 py-2 border border-red-500 hover:bg-red-500 hover:text-black transition-colors"
          >
            INITIATE SYSTEM REBOOT
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export const DarkFallback = () => <div style={{ position: 'fixed', inset: 0, background: '#07070b' }} />;
